import { useQuery } from "@tanstack/react-query"
import api from "@/lib/api"
import type { ReportVisibilityMap } from "@/lib/report-visibility"

export function useReportVisibility() {
  return useQuery({
    queryKey: ["report-visibility"],
    queryFn: async () => {
      const { data } = await api.get("/api/settings/report-visibility")
      return data.visibility as ReportVisibilityMap
    },
    staleTime: 60_000,
  })
}
